import { render, staticRenderFns } from "./AccountUpgradeRequest.vue?vue&type=template&id=57182754&scoped=true&"
import script from "./AccountUpgradeRequest.vue?vue&type=script&lang=js&"
export * from "./AccountUpgradeRequest.vue?vue&type=script&lang=js&"
import style0 from "./AccountUpgradeRequest.vue?vue&type=style&index=0&id=57182754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57182754",
  null
  
)

export default component.exports